import React, { useState } from 'react';
import { ParagraphWrapper, EmbedWrapper } from './style';
import sanitize from '../../../scripts/utils/sanitize';
import parse, { domToReact } from 'html-react-parser';
import Image from '../image';
import Video from '../video';
import { useRouter } from 'next/router';
import { Tooltip } from 'react-tooltip';

const Paragraph = ({ block, documentData, pageType }) => {
  const content = sanitize(block.content).__html;
  let counter = 0;

  const options = {
    replace: ({ attribs, children, name }) => {
      if (!attribs || (name !== 'h4' && name !== 'h5')) return;

      const [showToolip, setShowToolip] = useState(false);
      const childrenParsed = domToReact(children, options);
      const base = `https://${APP_SETTINGS.appUris.slice(-1)[0]}`;
      const router = useRouter();
      const headingIndex = counter++;
      const elementId = `${block.__component}-${block.id}-${headingIndex}`;

      const links = `${base}${router.asPath.split("#")[0]}#${elementId}`;
      const copyLink = (e) => {
        navigator.clipboard.writeText(links);
        setShowToolip(true);
        setTimeout(() => {
          setShowToolip(false);
        }, 750)
      }

      const tooltip = React.createElement(Tooltip, {
        className: 'ard-tooltip',
        id: `tt-${elementId}`,
        key: `tt-${elementId}`,
        'openEvents': ['click'],
        'openOnClick': true,
        'isOpen': showToolip,
        style: {
          margin: '0px 0px 12px 1px',
          borderRadius: '4px'
        }
      });
      // ARDONI7-51252: render source `h4` as `h2` and source `h5` as `h3` so
      // article-detail pages produce a valid h1 > h2 > h3 hierarchy. Source
      // tag names remain `h4`/`h5` (used by the anchor-list extractor in
      // article.js).
      const renderedTag = block.headingLevels?.[headingIndex] ?? (name === 'h4' ? 'h2' : 'h3');
      return React.createElement('div', { key: elementId, className: 'copy-id-h-tag' }, [
        React.createElement(renderedTag, {
          ...attribs,
          key: `${elementId}-h`,
          id: elementId,
          onClick: (e) => { copyLink(e); },
          'data-tooltip-content': "Link kopiert",
          'data-tooltip-id': `tt-${elementId}`,
          'data-tooltip-place': 'top-start',
          'data-tooltip-wrapper': 'span',
          'data-tooltip-variant': 'light',
          'data-tooltip-position-strategy': 'fixed',
          style: { cursor: 'pointer' }
        }, childrenParsed),
        tooltip
      ]);
    },
  };

  const imageAlignment = block.image?.alignment || 'Mittig';
  const videoAlignment = block.video?.alignment || 'Mittig';
  const hasImage = block.image?.media?.data;
  const hasVideo = block.video?.media?.data;
  const hasEmbed = block.embed?.snippet?.length;

  if (hasImage && (imageAlignment === 'Links' || imageAlignment === 'Rechts')) {
    return (
      <ParagraphWrapper
        id={`${block.__component}-${block.id}`}
        className={`primary-link paragraph paragraph-with-image paragraph-image-${imageAlignment}`}
      >
        <div className="paragraph-content-wrapper">
          {imageAlignment === 'Links' && <Image block={block.image} />}
          <div className="paragraph-text">
            {parse(content, options)}
          </div>
          {imageAlignment === 'Rechts' && <Image block={block.image} />}
        </div>
        {hasVideo && <Video block={block.video} />}
        {hasEmbed && <EmbedWrapper dangerouslySetInnerHTML={{ __html: block.embed.snippet }} />}
      </ParagraphWrapper>
    );
  }

  if (hasVideo && (videoAlignment === 'Links' || videoAlignment === 'Rechts')) {
    return (
      <ParagraphWrapper
        id={`${block.__component}-${block.id}`}
        className={`primary-link paragraph paragraph-with-video paragraph-video-${videoAlignment}`}
      >
        <div className="paragraph-content-wrapper">
          {videoAlignment === 'Links' && <Video block={block.video} />}
          <div className="paragraph-text">
            {parse(content, options)}
          </div>
          {videoAlignment === 'Rechts' && <Video block={block.video} />}
        </div>
        {hasImage && <Image block={block.image} />}
        {hasEmbed && <EmbedWrapper dangerouslySetInnerHTML={{ __html: block.embed.snippet }} />}
      </ParagraphWrapper>
    );
  }

  return (
    <>
      <ParagraphWrapper id={`${block.__component}-${block.id}`} className="primary-link paragraph">
        <div>{parse(content, options)}</div>
      </ParagraphWrapper>
      {hasVideo && <Video block={block.video} />}
      {hasImage && <Image block={block.image} />}
      {hasEmbed && <EmbedWrapper dangerouslySetInnerHTML={{ __html: block.embed.snippet }} />}
    </>
  );
};

export default Paragraph;
